import './Option.scss'
import numeric from '../../Utils/NumericFunction'
import {formatToPersianAddComma} from "../../Utils/CommaSeparator";

const Option = ({value=0, active=false, onKeyPress, onClick}) => {
  return (
    <div
      onClick={onClick(value)}
      onKeyPress={onKeyPress}
      className={`option ${active ? 'option-active' : ''}`}
    >
      <p value={value} className={``}>{formatToPersianAddComma(value)}</p>
    </div>
  )
}

export default Option